// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MonolithImageSizeFragmentDoc } from '../../useImageProps.generated';
import { ThreeSixtyFragmentDoc } from '../three-sixty/ThreeSixty.fragment.generated';
import { CatalogueVideoFragmentDoc } from '../../../graphql/api/product/catalogueVideo.fragment.generated';
export const ProductGalleryFragmentDoc = gql`
    fragment productGallery on CatalogueProduct {
  productName
  suffix
  images {
    __typename
    id
    large: size(name: LARGE) {
      ...monolithImageSize
    }
    large_x2: size(name: LARGE_X2) {
      ...monolithImageSize
    }
  }
  ... on CatalogueJewellery {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
  }
  ... on CatalogueEngagementRing {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
    centreStoneConstraints {
      shape {
        translation(locale: $locale) {
          name
        }
      }
    }
  }
  ... on CatalogueWeddingRing {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
  }
}
    ${MonolithImageSizeFragmentDoc}
${ThreeSixtyFragmentDoc}
${CatalogueVideoFragmentDoc}`;